import { render, staticRenderFns } from "./max-height.vue?vue&type=template&id=7afe563c&"
import script from "./max-height.vue?vue&type=script&lang=js&"
export * from "./max-height.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports